import { UNITS } from "./index";

export const MAX_HEIGHT = {
  value: 275,
  unit: UNITS.CENTIMETER,
};

export const MIN_HEIGHT = {
  value: 0,
  unit: UNITS.CENTIMETER,
};

export const MAX_AGE = {
  value: 130,
  unit: UNITS.YEAR,
};

export const MIN_WEIGHT = {
  value: 0,
  unit: UNITS.KILOGRAM,
};

export const SEXES = ["MALE", "FEMALE"];

export const MIN_STEPS = 0;
